import { BRAND_NAME, APP_DOMAIN, isLandingHost } from "../../constants/brand";
import { AppBar, Button, Grid, IconButton, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import landingpageStyle from '../../Styles/ComponentStyles/LandingPage/LandingPage.module.scss';
import hamburgerMenuIcon from "../../assets/Images/hamburgerMenuIcon.svg"
import GlobalPopUp from "../../GlobalComponent/GlobalPopup/GlobalPopup";
import ScheduleADemo from "../../GlobalComponent/ScheduleADemo/ScheduleADemo";
import LandingPageFooter from "../../GlobalComponent/LandingPageFooter/LandingPageFooter";
import newRBLogoForWhiteBg from '../../assets/Images/mar-lockup.svg'

const LandingPageWrapper = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [menuAnchorEl, setMenuAnchorEl] = useState<any>(null)
    const isBelow896 = useMediaQuery('(max-width:896px)')
    const [flagOpenScheduleDemoDialog, setFlagOpenScheduleDemoDialog] = useState(false)

    const handleMenuClick = (e: any) => {
        setMenuAnchorEl(e?.currentTarget)
    }

    const handleContactUsClick = () => {
        setMenuAnchorEl(null); // Close mobile menu if open
        navigate("/contact-us");
    }

    const handleScheduleDemoBtnClick = () => {
        // setFlagOpenScheduleDemoDialog(true)
        window.open("https://calendly.com/marketing-sales-brokersalliance/30min", "_blank")
    }

    return (
        <>
            {flagOpenScheduleDemoDialog &&
                <GlobalPopUp
                    open={flagOpenScheduleDemoDialog}
                    onClose={() => setFlagOpenScheduleDemoDialog(false)}
                    flagDivider={true}
                    title={"Schedule a Demo"}
                    paperProps={{
                        sx: {
                            width: "800px"
                        }
                    }}
                >
                    <ScheduleADemo />
                </GlobalPopUp>

            }
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>

                        <Grid item xs={12}>
                            <AppBar component={'nav'} className={landingpageStyle.appNavbarCustomStyle}>
                                <Grid container className={landingpageStyle.navbarContainer} justifyContent={"space-between"}>
                                    {/* {
                                        (companyDetails?.company_full_logo) &&
                                        <Grid item sx={{ paddingLeft: "10px" }}>
                                            <img width={"210px"} src={companyDetails?.company_full_logo || rbLogoFull} alt={BRAND_NAME} />
                                        </Grid>
                                    } */}
                                    <img src={newRBLogoForWhiteBg} alt={BRAND_NAME} height={"28px"} />
                                    {isBelow896 ?
                                        <>
                                            <IconButton onClick={(e) => handleMenuClick(e)}>
                                                <img src={hamburgerMenuIcon} alt="menu" />
                                            </IconButton>
                                            <Menu
                                                anchorEl={menuAnchorEl}
                                                open={Boolean(menuAnchorEl)}
                                                onClose={() => setMenuAnchorEl(null)}
                                            >
                                                <MenuItem onClick={() => {
                                                    setMenuAnchorEl(null);
                                                    navigate("/");
                                                }}>
                                                    <Grid
                                                        item
                                                        className={`${landingpageStyle.navItems} ${location.pathname === "/" ? landingpageStyle.activeNavItem : ""}`}
                                                    >
                                                        Home
                                                    </Grid>
                                                </MenuItem>
                                                <MenuItem onClick={handleContactUsClick}>
                                                    <Grid
                                                        item
                                                        className={`${landingpageStyle.navItems} ${location.pathname === "/contact-us" ? landingpageStyle.activeNavItem : ""}`}
                                                    >
                                                        Contact Us
                                                    </Grid>
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() => {
                                                        setMenuAnchorEl(null);
                                                        if (isLandingHost(window?.location?.host)) {
                                                            window.location.href = `https://app.${APP_DOMAIN}/login`;
                                                        } else {
                                                            navigate("/login");
                                                        }
                                                    }}
                                                // sx={{ backgroundColor: "rgba(59, 120, 206, 1)", color: "white" }}
                                                >
                                                    <Grid item>Login</Grid>
                                                </MenuItem>
                                            </Menu>
                                        </>
                                        :
                                        <>
                                            <Grid item>
                                                <Grid container alignItems={"center"} gap={"30px"}>
                                                    <Grid item>
                                                        <Grid container gap={"16px"}>
                                                            <Grid
                                                                item
                                                                className={`${landingpageStyle.navItems} ${location.pathname === "/" ? landingpageStyle.activeNavItem : ""}`}
                                                                onClick={() => navigate("/")}
                                                            >
                                                                Home
                                                            </Grid>
                                                            {/* <Grid
                                                                item
                                                                className={`${landingpageStyle.navItems}`}
                                                            // onClick={() => navigate("/")}
                                                            >
                                                                Solutions
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                className={`${landingpageStyle.navItems}`}
                                                            // onClick={() => navigate("/")}
                                                            >
                                                                About Us
                                                            </Grid> */}
                                                            <Grid
                                                                item
                                                                className={`${landingpageStyle.navItems} ${location.pathname === "/contact-us" ? landingpageStyle.activeNavItem : ""}`}
                                                                onClick={handleContactUsClick}
                                                            >
                                                                Contact Us
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems={"center"} gap={1}>
                                                            <Grid item>
                                                                <Button
                                                                    className={landingpageStyle.navbarReqDemoBtn}
                                                                    onClick={handleScheduleDemoBtnClick}
                                                                >
                                                                    Schedule a Demo
                                                                </Button>
                                                            </Grid>
                                                            <Grid item>
                                                                <Button
                                                                    className={landingpageStyle.navbarLearnMoreBtn}
                                                                    onClick={() => {
                                                                        if (isLandingHost(window?.location?.host)) {
                                                                            window.location.href = `https://app.${APP_DOMAIN}/login`;
                                                                        } else {
                                                                            navigate("/login");
                                                                        }
                                                                    }}
                                                                >
                                                                    Login
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </AppBar>
                        </Grid>

                        <Grid item xs={12} paddingTop={"60px"}>
                            <Outlet />
                        </Grid>

                        <LandingPageFooter />

                    </Grid>
                </ Grid>
            </Grid>
        </>
    )
}

export default LandingPageWrapper